if (!customElements.get('product-bottom-bar')) {
  customElements.define(
    'product-bottom-bar',
    class ProductBottomBar extends HTMLElement {

        constructor() {
            super()
            this.sectionId = this.dataset.sectionId
            this.curDocEle = window.document.documentElement;
        }

        connectedCallback() {
            this.deliveryTipDom = this.querySelector('.delivery-tip');

            this.deliveryTipDom.querySelector('.close-icon').addEventListener('click', () => {
                this.deliveryTipDom.style.display = 'none';
            });

            this.buyButtonFormDom = this.curDocEle.querySelector('.product__block--buy_buttons .product-form__buttons');
            this.headerDom = this.curDocEle.querySelector('.shopify-section--header');
            this.variantInput = this.querySelector('input.product-variant-id')

            this.backToDropDom = this.curDocEle.querySelector('.back-to-top');

             window.addEventListener('scroll', (e) => {
                this.checkShowBottomBar();
            });
            this.checkShowBottomBar();

            FoxTheme.pubsub.subscribe(
                FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
                this.handleVariantChange
            );
        }

        checkShowBottomBar = () => {
            const bottomBarDom = this
            const diffBuffer = 50
            let buyButtonFormDom = this.buyButtonFormDom, headerDom = this.headerDom
            if (!buyButtonFormDom) {
              buyButtonFormDom = this.curDocEle.querySelector('.product__block--buy_buttons .product-form__buttons');
            }
            if (!headerDom) {
              headerDom = this.curDocEle.querySelector('.header-section');
            }

            if (!this.backToDropDom) {
              this.backToDropDom = this.curDocEle.querySelector('.back-to-top');
            }
            const buyButtonFormDomRect = buyButtonFormDom.getBoundingClientRect();
            const scrollTop = this.curDocEle.scrollTop;
            const minTop = 60; //headerDom.getBoundingClientRect()?.bottom ?? 0;
            if (
              this.curDocEle.clientHeight - diffBuffer < buyButtonFormDomRect.top ||
              buyButtonFormDomRect.bottom < minTop + diffBuffer
            ) {
              bottomBarDom.style.bottom = '0';
              if (this.backToDropDom) {
                this.backToDropDom.style.bottom = '110px';
              }
            } else {
              bottomBarDom.style.bottom = '-200px';
              if (this.backToDropDom) {
                this.backToDropDom.style.bottom = '1.5rem';
              }
            }
        };

        handleVariantChange = (event) => {
            const { html, variant, sectionId } = event.data ?? {}

            const addButtonUpdated = html.getElementById(
                `ProductSubmitButton-${sectionId}`
            );

            if (!this.variantInput) {
              this.variantInput = this.querySelector('input.product-variant-id')
            }
            this.variantInput.setAttribute('value', variant.id)
            
            this.toggleAddButton(
                addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
                FoxTheme.variantStrings.soldOut
            );
        }

        toggleAddButton(disable = true, text, modifyClass = true) {
            const productForm = this.querySelector(
            `#product-form-${this.sectionId}`
            );
            if (!productForm) return;
            const addButton = productForm.querySelector('[name="add"]');
            const addButtonText = productForm.querySelector('[name="add"] > span');
            if (!addButton) return;

            if (disable) {
                addButton.setAttribute("disabled", "disabled");
                if (text) addButtonText.textContent = this.decoded(text);
            } else {
                addButton.removeAttribute("disabled");
                addButtonText.textContent = this.decoded(
                    FoxTheme.variantStrings.addToCart
                );
            }

            if (!modifyClass) return;
        }

        decoded(text) {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = text;
            const decoded = tempDiv.textContent;
            return decoded;
        }
    }
  )
}